module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "Menu"
  }, _vm._l((_vm.global.menu), function(item, index) {
    return _c('router-link', {
      key: 'menuItem' + index,
      staticClass: "Menu-item",
      attrs: {
        "to": {
          path: item.path
        }
      }
    }, [_vm._v("\n    " + _vm._s(item.title) + "\n  ")])
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08f62fa2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuComponent.vue
// module id = 739
// module chunks = 1474